<template>
  <div :class="type === 'dashboard-notifications' ? 'pr-8 pl-25':'pl-21 pr-10 pt-174' ">
    <div class="p-0 pb-60">
      <div
        :class="type === 'dashboard-notifications' ? 'no-notifications-height' : 'no-notifications'"
        v-if="Object.keys(notificationListByDate).length == 0 && !loaderStatus"
      >
        {{ $t('notificationEmptyStateMessage')}}
      </div>
      <div class="p-0 alert-list">
        <div
          :key="index"
          v-for="(notifications, key, index) in notificationListByDate"
        >
          <!-- <div class="human_readable_date pl-10" v-if="!dashboard">
            <div v-if="key === today()">Today</div>
            <div v-else-if="key === yesterday()">Yesterday</div>
          </div> -->
          <div
            class="notification_box row"
            :class="[notification.count!==1&&notification.count%2===0?'notifications_table':'', (notification.count%2!==0) && 'odd_row_color']"
            :key="index"
            v-for="(notification, index) in notifications"
          >
            <!-- When regulatory alert not exist -->
            <!-- Do not use indexOf in same tag for multiple times(Will be a performant factor when string/Array is larger) better to create a new html tag -->
            <div
              v-if="notification.type.indexOf('regulatory_alert') === -1"
              class="col-xs-12 pl-0 cursor-pointer test pr-0"
              @click="getProductRelatedDetails(notification.registrationId)"
            >
            <div class="col-xs-9 pl-6">
              <div class="notifications-icon-message d-flex">
                <notification-icons
                :type="notification.notificationType" :message="notification.notification_message"
                ></notification-icons>
                <!-- <div> -->
                  <!-- <img class="small_img" src="/static/images/icons/new_notification.svg" alt /> -->
                <!-- </div> -->
                <div class="notification_message cursor-pointer" :title="showMessage(notification)">
                   {{ notification.notification_message }}<span v-if="['consolidation_download','moved_to_manage_compliance','to-do-checklist-completed','record_expiration'].includes(notification.notificationType)"></span>
                   <span v-else> {{ $t('by')}} {{notification.creater_name}}</span>
                </div>

              </div>
            </div>
            <div class="col-xs-3 p-0 d-flex justify-content-end">
              <span class=" notification_date pr-0" :class="type !== 'dashboard-notifications' && 'pr-17'">{{ date(key) }}</span>
            </div>
              <!-- <span class="col-xs-12 notification_date" v-if="key === today()">{{ $t('today')}}</span>
              <span class="col-xs-12 notification_date" v-else-if="key === yesterday()">{{ $t('yesterday')}}</span> -->
              <!-- <span class="col-xs-12 notification_date" v-else>{{ date(key) }}</span> -->

              <!-- <div class="col-xs-12" v-if="notification != Object.values(notificationListByDate)[Object.keys(notificationListByDate).length - 1][notifications.length - 1]"><hr/></div> -->
            </div>
            <!-- When regulatory alert exists -->
            <!-- <div
              v-else-if="notification.type.indexOf('regulatory_alert') > -1"
              class="col-xs-12 d-flex mb-20 pl-0 test"
            >
              <notification-icons
                :type="notification.notificationType"
              ></notification-icons>
              <div class="pl-15 word-break title-alert" style="color: red;">
                {{ notification.title }}
              </div>
            </div> -->
            <!-- Notification content here -->
            <!-- <div class="col-xs-12 notification-content word-break">
              <div class="col-xs-12 font-medium mb-15">
                Date: <span class="font-300">{{ date(key) }}</span>
              </div>
              <div
                v-if="notification.type.indexOf('regulatory_alert') === -1"
                @click="getProductRelatedDetails(notification.registrationId)"
                class="col-xs-12 font-300 cursor-pointer"
              >
                {{ notification.notification_message }}
              </div>
              <div
                v-else-if="notification.type.indexOf('regulatory_alert') > -1"
                class="col-xs-12 font-300"
                v-html="notification.notification_message"
              ></div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="col-md-9 alert-list">
        <div
          :key="index"
          v-for="(notifications, key, index) in notificationListByDate"
        >
          <div class="human_readable_date">
            <div v-if="key === today()">Today</div>
            <div v-else-if="key === yesterday()">Yesterday</div>
          </div>
          <div
            class="notification_box row"
            :key="index"
            v-for="(notification, index) in notifications"
          >
            <div class="box_header col-md-12 col-sm-12 col-xs-12">
              <div class="row">
                <div
                  class="col-md-11 col-md-offset-1 col-xs-11 col-sm-11 col-xs-offset-2 col-sm-offset-2 pd_lt_0"
                >
                  <div class="col-md-10 pd_lt_0 col-xs-10 col-sm-10">
                    {{ date(key) }}
                  </div>
                  <div class="col-md-1 col-sm-1 col-xs-1 col-md-offset-1">
                    <notification-icons
                      :type="notification.notificationType"
                    ></notification-icons>
                  </div>
                  <div class="col-md-10 col-xs-10 col-sm-9 date_underline">
                    <hr />
                  </div>
                  <div class="col-md-1 col-xs-1 col-sm-1 underline_dot"></div>
                </div>
              </div>
            </div>
            <div
              @click="getProductRelatedDetails(notification.registrationId)"
              class="col-md-12 padding-reset registration cursor"
              v-if="notification.type.indexOf('regulatory_alert') === -1"
            >
              <div class="row mr_bt_5">
                <div class="col-md-1 col-xs-2 col-sm-2 icon_box">
                  <img
                    src="/static/images/icons/track_plus_icon_blue.svg"
                    alt
                  />
                </div>
                <div class="title-alert col-xs-8 col-sm-10 pd_lt_0 col-md-10">
                  {{ notification.title }}
                </div>
              </div>
              <div class="row mr_bt_10">
                <div
                  class="col-md-10 pd_lt_0 col-sm-10 col-sm-offset-2 col-md-offset-1"
                >
                  <div class="description-alert hidden-xs">
                    {{ notification.notification_message }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-12 padding-reset registrations"
              v-if="notification.type.indexOf('regulatory_alert') > -1"
            >
              <div class="row mr_bt_5">
                <div class="col-md-1 col-xs-2 col-sm-2 icon_box">
                  <img
                    src="/static/images/icons/track_plus_icon_blue.svg"
                    alt
                  />
                </div>
                <div class="col-md-10 col-sm-10 pd_lt_0 col-xs-8">
                  <div class="title-alert" style="color: red;">
                    {{ notification.title }}
                  </div>
                </div>
              </div>
              <div class="row mr_bt_10">
                <div
                  class="col-md-offset-1 col-md-10 pd_lt_0 col-sm-10 col-sm-offset-2 description-alert hidden-xs"
                  v-html="notification.notification_message"
                ></div>
                <li style="display: grid;">
                  <a
                    class="alert-link"
                    :href="linkDetail['link']"
                    target="_blank"
                    :key="index"
                    v-for="(linkDetail, index) in notification.linkList"
                    >{{ linkDetail['label'] }}</a
                  >
                </li>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
      <div v-if="Object.keys(notificationListByDate).length != 0" class="col-xs-12 footer p-0">
        <div class="col-xs-12 p-0">
          <span v-if="!this.$route.path.includes('alert')">
            <!-- <router-link class="seeMore" to="/layout/alert">{{$t('viewAll')}}</router-link> -->
            <button type="button" class="btn view_all_button" @click="viewAll">
            <span class="seeMore pr-8">{{ $t('viewAll') }}</span>
              <img src="/static/images/icons/Back.svg" class="arrow_image pb-3" />
          </button>

          </span>
        </div>
      </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <!-- <registration-details-popup
      :permissions="permissions"
      :dataRow="activeProductRegistration"
      @hidePopup="hidePopup"
      :archivedFlag="activeProductRegistration.is_archived"
      :reportFlag="true"
    ></registration-details-popup> -->
    <permission-access-modal></permission-access-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import * as moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';
// import registrationDetailsPopup from '../Registrations/RegistrationDetailsPopup.vue';
import NotificationIcons from './NotificationIcons.vue';
import PermissionAccessModal from '../Common/PermissionAccessModal.vue';
import {
  getUserNotificationsAlert,
  getUserNewNotificationsCount,
} from '../../apis/notification';
import { getRegistrationDetailsById } from '../../apis/registrations';
// import validateRegDetailsData from '../../utils/registrationDetails';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';

export default {
  mixins: [permissionsList],
  components: {
    PermissionAccessModal,
    Loader,
    // registrationDetailsPopup,
    NotificationIcons,
  },
  props: ['startDate', 'endDate', 'notificationsStarMarkCount', 'dashboard', 'type'],
  data() {
    return {
      permissions: [],
      initalAPICall: false,
      newAlertsCount: 0,
      newNotificationCount: 0,
      loaderStatus: false,
      notificationListByDate: {},
      editFlag: false,
      activeProductRegistration: {},
      activeId: '',
      notificationTypes: [
        'added',
        'deleted',
        'modified',
        'expired',
        'expiring',
        'welcome',
        'active',
        'mail',
        'pending',
      ],
    };
  },
  methods: {
    showMessage(notification) {
      const message = this.$i18n.locale === 'Portuguese' ? `${notification.notification_message} por ${notification.creater_name}` : `${notification.notification_message} by ${notification.creater_name}`;
      return ['consolidation_download', 'moved_to_manage_compliance', 'to-do-checklist-completed', 'record_expiration'].includes(notification.notificationType) ? notification.notification_message : message;
    },
    viewAll() {
      this.$router.push('/layout/alert');
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    async validateFeatures() {
      this.loaderStatus = true;
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      this.loaderStatus = false;
    },
    async getNewNotificationsCount() {
      // To highlight tab level for Reg Tracker
      const response = await getUserNewNotificationsCount();
      EventBus.$emit('userNewNotificationsCount', response);
    },
    async getProductRelatedDetails(regiId) {
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else if (regiId) {
        this.loaderStatus = true;
        const selectedRegistration = await getRegistrationDetailsById(regiId);
        this.loaderStatus = false;
        const id = selectedRegistration.registration_id;
        if (selectedRegistration && !id) {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Registro não encontrado!' : 'Registration is not found!',
            group: 'custom-notification',
          });
        } else if (selectedRegistration) {
          this.$router.push({ path: `/layout/view-record/${regiId}?type=notifications` });
        }
      }
    },
    hidePopup(value) {
      this.editFlag = value;
    },
    viewRegistration(record) {
      this.loaderStatus = false;
      this.$router.push({ path: `/layout/view-record/${record.registrationId}?type="compliance"` });
    },
    date(date) {
      if (date === 'N/A') {
        return this.$i18n.locale === 'Portuguese' ? 'N/D' : date;
      }
      const formattedDate = this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
      return formattedDate;
    },

    today() {
      return moment().format('YYYY-MM-DD');
    },
    yesterday() {
      return moment()
        .add(-1, 'days')
        .format('YYYY-MM-DD');
    },
    async viewRegTrackerNotifications() {
      this.newAlertsCount = 0;
      this.newNotificationCount = 0;
      this.loaderStatus = true;
      this.notificationListByDate = {};
      const startAlertDate = moment(this.startDate).format('YYYY-MM-DD');
      const endAlertDate = moment(this.endDate).format('YYYY-MM-DD');
      const alertDateObj = {
        startAlertDate,
        endAlertDate,
      };
      if (alertDateObj.startAlertDate === 'Invalid date' && alertDateObj.endAlertDate === 'Invalid date') {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Tanto a data de início quanto a data de fim são obrigatórias'
              : 'Both Start date and End date are mandatory',
          group: 'custom-notification'
        });
        this.loaderStatus = false;
        return;
      }
      const response = await getUserNotificationsAlert(alertDateObj);
      let notifArray = response;
      if (this.dashboard) {
        notifArray = notifArray.slice(0, 4);
      }
      EventBus.$emit('regTrackerCount', response.length);
      let count = 0;
      notifArray.forEach((data) => {
        if (
          Object.keys(this.notificationListByDate).indexOf(
            moment.utc(data.creation_date).format('YYYY-MM-DD'),
          ) === -1
        ) {
          count += 1;
          this.notificationListByDate[
            moment.utc(data.creation_date).format('YYYY-MM-DD')
          ] = [];
          this.notificationListByDate[
            moment.utc(data.creation_date).format('YYYY-MM-DD')
          ].push({
            creater_name: data.creater_name,
            country_code: data.country_code,
            is_seen: data.is_seen,
            linkList: JSON.parse(data.notification_link),
            notification_message: data.notification_message,
            title: data.title,
            type: data.notification_type,
            alertId: data.refrence_id,
            registrationId: data.registration_id,
            notificationType: data.notification_type,
            count,
          });
        } else {
          count += 1;
          this.notificationListByDate[
            moment.utc(data.creation_date).format('YYYY-MM-DD')
          ].push({
            creater_name: data.creater_name,
            country_code: data.country_code,
            is_seen: data.is_seen,
            linkList: JSON.parse(data.notification_link),
            notification_message: data.notification_message,
            title: data.title,
            type: data.notification_type,
            alertId: data.refrence_id,
            registrationId: data.registration_id,
            notificationType: data.notification_type,
            count,
          });
        }
      });
      this.loaderStatus = false;
    },
    filterNotificationType(title) {
      const titleArray = title.split(' ');
      const that = this;
      const notificationType = titleArray.find((titleVal) => that.notificationTypes.find(
        (type) => type.toLowerCase() === titleVal.toLowerCase(),
      ));
      return typeof notificationType !== 'undefined'
        ? notificationType.toLowerCase()
        : '';
    },
  },
  watch: {
    startDate() {
      if (this.startDate !== null && this.startDate !== '' && this.endDate !== null && this.endDate !== '') {
        this.viewRegTrackerNotifications();
      }
    },
    endDate() {
      if (this.endDate !== null && this.endDate !== '' && this.startDate !== null && this.startDate !== '') {
        this.viewRegTrackerNotifications();
      }
    },
  },
  async created() {
    this.loaderStatus = true;
    await this.validateFeatures();
    await this.viewRegTrackerNotifications();
    if (this.notificationsStarMarkCount.registration_tracker_count > 0) {
      await this.getNewNotificationsCount();
    }
    this.loaderStatus = false;
  },
  mounted() {
    $('#registrationComponent').modal('hide');
    EventBus.$on('loadActiveNotificationTab', async () => {
      this.loaderStatus = true;
      await this.viewRegTrackerNotifications();
      if (this.notificationsStarMarkCount.registration_tracker_count > 0) {
        await this.getNewNotificationsCount();
      }
      this.loaderStatus = false;
    });
  },
  beforeDestroy() {
    EventBus.$off('loadActiveNotificationTab');
  },
};
</script>
<style scoped src="../../../public/static/css/notification-widget.css"></style>
<style scoped>
/* .notification_box.row.odd_row_color {
  background: #EBEBEB;
} */
.pt-174 {
  padding-top: 172px;
  min-height: calc(100vh - 50px);
}
.complete-background {
  background: #EBEBEB !important;
}
.view_all_button,
.view_all_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}
.notifications_table {
  background: #F5F5F5;
  height: 52px;
}
.odd_row_color {
  background: #FAFAFA;
  height: 52px;
}
.arrow_image {
  width: 22px;
  height: 25px;
}
.no-notifications {
  padding-bottom: 56px;
  height: 100vh;
}
.no-notifications-height {
  height: auto;
  text-align: center;
}
.pr-8 {
  padding-right: 8px;
}
.pr-17 {
  padding-right: 17px;
}
.pr-10{
  padding-right: 10px;
  background: #EBEBEB;
}
.pr-10 {
  padding-right: 10px;
}
.pl-21 {
  padding-left: 25px;
}
.pl-6{
  padding-left: 6px;
}
.pb-60 {
  padding-bottom: 60px;
}
.pt-12 {
  padding-top:12px
}
.alert-list{
  padding-right: 15px;
}
.footer{
  position:absolute;
  /* padding-top: 30px; */
  text-align: right;
  bottom: 8px;
  right: 8px;
  /* padding-right: 10px; */
}
.seeMore{
  /* font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  text-align: right; */
   color: #FFFFFF;
  /* padding-bottom: 20px; */
}
.notifications-icon-message{
  display: inline-flex;
}
/* img {
  width: 28px;
  height: 28px;
} */

.notification_box {
  /* margin: 0px 0px 10px 0px; */
  /* padding: 25px 25px 25px 10px; */
  padding: 14px 0px 16px 8px;
  margin: 0px;
  /* border-bottom: 0.5px solid #C4C4C4; */
  box-shadow: none;
  border-radius: 0;
}
.notification_box.remove-border-bottom {
  border-bottom: none !important;
}

/* .notification_box:last-child {
  border-bottom: none;
  padding-bottom: 0px;
} */
.notification_message {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
  padding-left: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 920px;
}
.notification_date {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #3E3E3E;
  /* padding-right: 23px; */

}
@media screen and (min-width: 1301px) and (max-width: 1366px){
  .notification_message {
    max-width: 880px;;
  }
}
</style>
